export enum CastType {
  EPOCHS_SECS = 'EpochSecs',
  EPOCHS_MILLIS = 'EpochMillis',
  MERGE_PARAM = 'MergeParam',
}
